import style from "./CurrentStreakCard.module.css";
import streakFire from "@/assets/images/decorative/streak_fire.svg";

import { padZero, getLabel, formatLocalDate } from "@/utils/helpers";

function CurrentStreakCard({ activity }) {
	const streakCount = calculateCurrentStreak(activity);

	function calculateCurrentStreak(activityDates) {
		if (!Array.isArray(activityDates) || activityDates.length === 0) {
			return 0;
		}

		// Convert dates to local YYYY-MM-DD format
		const activitySet = new Set(activityDates.map(formatLocalDate));

		let streak = 0;
		const today = new Date();
		today.setHours(0, 0, 0, 0);

		let currentDate = new Date(today);

		// Check if there's activity today or yesterday
		const todayStr = formatLocalDate(currentDate);

		// Create yesterday date
		const yesterday = new Date(today);
		yesterday.setDate(yesterday.getDate() - 1);
		const yesterdayStr = formatLocalDate(yesterday);

		// If no activity today or yesterday, streak is 0 (24h gap rule)
		if (!activitySet.has(todayStr) && !activitySet.has(yesterdayStr)) {
			return 0;
		}

		// Start from today or yesterday (whichever has activity)
		if (activitySet.has(todayStr)) {
			currentDate = new Date(today);
		} else {
			currentDate = new Date(yesterday);
		}

		while (true) {
			const dateStr = formatLocalDate(currentDate);

			if (activitySet.has(dateStr)) {
				streak++;
				currentDate.setDate(currentDate.getDate() - 1);
			} else {
				break;
			}
		}

		return streak;
	}

	return (
		<div className={style.card}>
			<div className={style.header}>
				<div className={style.count}>{padZero(streakCount)}</div>
				<span>
					{getLabel(streakCount, {
						singular: "Dan",
						dual: "Dana",
						plural: "Dana",
					})}
				</span>
			</div>
			<div className={style.decoration}>
				<img src={streakFire}></img>
			</div>
		</div>
	);
}

export default CurrentStreakCard;
